import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import produce from 'utils/produce';
import { Alert } from 'components/base';
import { capitalizeString } from 'utils/format';
import {
  haveProductsOptions,
  getProductsOptions,
  isListOfColoredDisplayProducts,
  getColoredDisplayProductIds,
  getRelatedProductsIds,
} from 'data/lib/product';
import ConfigurationSection from './configurationSection';

const OptionConfigurator = props => {
  const [selectedOptions, setSelectedOptions] = useState({});

  useEffect(() => {
    if (haveProductsOptions(props.products)) {
      let isValid = true;

      const options = {};
      getProductsOptions(props.products).forEach(([key, values]) => {
        if (values.indexOf(selectedOptions[key]) < 0) {
          isValid = false;
        }
        options[key] = values[0];
      });

      if (!isValid) {
        setSelectedOptions(options);
      }
    }
  }, [props.products]);

  useEffect(() => {
    props.onChange(selectedOptions);
  }, [props.primaryProduct?.id, selectedOptions]);

  const handleOnOptionChange = (key, value) => {
    setSelectedOptions(
      produce(selectedOptions, draft => {
        draft[key] = value;
      }),
    );
  };

  const renderNotAvailableAlert = (key, value) => {
    if (key && value) {
      let message;

      const productIds = props.products.map(p => p.id);
      // TODO - it's not need to be colored items
      if (isListOfColoredDisplayProducts(productIds)) {
        // new approach
        const allIds = getColoredDisplayProductIds(getRelatedProductsIds(props.primaryProduct), {
          [key]: value,
        });
        const availableProductIds = getColoredDisplayProductIds(productIds, { [key]: value });

        const notAvailableIds = allIds.filter(id => availableProductIds.indexOf(id) < 0);

        const aliases = [];
        if (props.primaryProduct) {
          props.primaryProduct.relatedTo.forEach(item => {
            if (typeof item === 'object') {
              const sku = Object.keys(item)[0];
              if (notAvailableIds.indexOf(sku) >= 0) {
                aliases.push(item[sku].alias);
              }
            }
          });
        }

        if (aliases.length > 0) {
          message = `${capitalizeString(value)} ${key} is out of stock for ${aliases.join(
            ', ',
          )} prints.`;
        }
      } else {
        // old approach - it's not used anymore
        const notAvailableProducts = props.products.filter(
          product =>
            product.templateMetaData.options[key] &&
            product.templateMetaData.options[key].indexOf(value) < 0,
        );

        if (notAvailableProducts.length > 0) {
          const skus = notAvailableProducts.map(p => p.id);
          const names = notAvailableProducts.map(p => p.templateMetaData.name);

          const aliases = [];
          if (props.primaryProduct) {
            props.primaryProduct.relatedTo.forEach(item => {
              if (typeof item === 'object') {
                const sku = Object.keys(item)[0];
                if (skus.indexOf(sku) >= 0 && item[sku].alias) {
                  aliases.push(item[sku].alias);
                }
              }
            });
          }

          message = `${capitalizeString(value)} ${names.join(', ')} are out of stock${
            aliases.length > 0 ? ` for ${aliases.join(', ')} prints.` : `.`
          }`;
        }
      }

      if (message) {
        return (
          <Alert type="danger" className="text-center">
            {message}
          </Alert>
        );
      }
    }

    return null;
  };

  if (haveProductsOptions(props.products)) {
    return (
      <>
        {getProductsOptions(props.products).map(([key, values]) => (
          <React.Fragment key={key}>
            <ConfigurationSection
              key={`${props.primaryProduct?.id}-${key}`}
              templateRootPath={props.products[0].templateRootPath}
              id={key}
              label={`Select ${props.labels[key] ?? key}`}
              options={values.map(value => ({ id: value, label: value }))}
              selectedOptionId={selectedOptions[key]}
              onChange={handleOnOptionChange}
              minNumberOfItems={props.minNumberOfItems}
              cardClassName={props.cardClassName}
            />
            {renderNotAvailableAlert(key, selectedOptions[key])}
          </React.Fragment>
        ))}
      </>
    );
  }
  // TODO when upsell offers something different with no options - render ConfigurationSection with all the products
  return null;
};

OptionConfigurator.propTypes = {
  products: PropTypes.array.isRequired,
  labels: PropTypes.object,
  primaryProduct: PropTypes.object,
  minNumberOfItems: PropTypes.number,
  onChange: PropTypes.func,
  cardClassName: PropTypes.string,
};

OptionConfigurator.defaultProps = {
  labels: {},
};

export default OptionConfigurator;
